// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class CppDeliveryInstructionService {
  public redirectFrom: any;

  constructor(public configService: ConfigService, public networkService: NetworkService) { }
  editDeliveryAccountNo: any;
  // Get Delivery Instructions List
  public getDeliveryInstructionList(dashboardFilter) {
    return this.networkService.postRequest(this.configService.getcppGetDeliveryInstructionListUrl(), dashboardFilter);
  }

  // Get Delivery Instructions List
  public getDeliveryInstructionAccountList() {
    return this.networkService.getRequest(this.configService.getDeliveryInstructionAccountsList());
  }
  // saveDeliveryInstruction
  public saveDeliveryInstruction(payload) {
    return this.networkService.postRequest(this.configService.getCPPDeliveryInstructionEditData(), payload);
  }
  // get view/edit data
  public getDeliveryInstruction(accountNumber) {
    return this.networkService.getRequest(this.configService.getCPPDeliveryInstructions() + '?accountNumber=' + accountNumber);
  }

  public deleteDeliveryInstruction(payload) {
    return this.networkService.postRequest(this.configService.getCPPDeliveryInstructionDeleteData(), payload);
  }
}
